var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPackhouse = function SvgPackhouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.417 54.583h49.166",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.752 54.583.123-29.573c0-1.5.713-2.926 1.893-3.86L26.976 7.752c1.77-1.376 4.253-1.376 6.048 0l17.208 13.374a4.89 4.89 0 0 1 1.893 3.884v29.573",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.604 27.542H21.396a3.683 3.683 0 0 0-3.688 3.687v23.354h24.584V31.23a3.683 3.683 0 0 0-3.688-3.687ZM25.083 40.448v3.688M26.313 18.938h7.375",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPackhouse;